import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom/cjs/react-router-dom"
import { Table } from "rsuite"

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} className="table-link" title={rowData[dataKey]}>
            <Link to={`/suppliers/relatedsupplier/${rowData.id}`} target="_blank">{rowData[dataKey]}</Link>
        </Cell>
    )
}

const ChildSuppliers = ({ tableData = [] }) => {
    const columns = [
        {
            name: 'suppliername',
            label: 'Supplier Name',
            width: 250
        },
        {
            name: 'domainName',
            label: 'Domain Name',
            width: 100
        },
        {
            name: 'companyId',
            label: 'Customer ID',
            width: 100
        },
        {
            name: 'address1',
            label: 'Address',
            width: 150
        },
        {
            name: 'city',
            label: 'City',
            width: 100
        },
        {
            name: 'abbreviatedState',
            label: 'State',
            width: 100
        },
        {
            name: 'zip',
            label: 'Zip',
            width: 100
        }
    ]

    const [data, setData] = useState([])
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)

    useEffect(() => {
        if (tableData && tableData?.length) {
            setData(tableData)
        } else {
            setData([])
        }
    }, [tableData])

    const headerElements = columns.map((col, index) => {
        if (index === 0) {
            return (
                <Column
                    resizable
                    sortable
                    key={col.name}
                    width={col.width}
                >
                    <HeaderCell className="fw-bold text-black" title={col.label}>{col.label}</HeaderCell>
                    <LinkCell dataKey={col.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                sortable
                key={col.name}
                width={col.width}
            >
                <HeaderCell className="fw-bold text-black" title={col.label}>{col.label}</HeaderCell>
                <Cell dataKey={col.name} />
            </Column>
        )
    })

    const paginatedData = data?.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
            x = x.charCodeAt();
        }
        if (typeof y === 'string') {
            y = y.charCodeAt();
        }
        if (sortType === 'asc') {
            return x - y;
        } else {
            return y - x;
        }
    }).slice(limit * (page - 1), limit * page)

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    return (
        <div className="card supply-child-vendor mt-0">
            <div className="card-content">
                <Table
                    virtualized
                    height={500}
                    affixHeader={true}
                    data={paginatedData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                    loading={loading}
                >
                    {headerElements}
                </Table>
                <div className="child-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        maxButtons={5}
                        activePage={page}
                        showInfo
                        layout={['limit', '|', 'pager']}
                        displayLength={limit}
                        total={data.length}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        onChangePage={(event) => { setPage(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div>
            </div>
        </div>
    )
}

export default ChildSuppliers